export default __webpack_public_path__ + "static/media/attandance.e0b70736.png";